import { render } from "./BreedKeeper.vue?vue&type=template&id=72acc13b"
import script from "./BreedKeeper.vue?vue&type=script&lang=js"
export * from "./BreedKeeper.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__